import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { bannerEligible } from "./InstallBanner";

// Floating install button for first-time installable visitors. Repeat riders get the
// richer InstallBanner instead, so this hides whenever the banner is eligible.
export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setDeferred(null); setGone(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!deferred || gone || bannerEligible()) return null;

  const install = async () => {
    deferred.prompt();
    try { await deferred.userChoice; } catch { /* ignore */ }
    setDeferred(null);
  };

  return (
    <button
      onClick={install}
      data-testid="install-app-btn"
      className="fixed bottom-6 right-6 z-[60] flex items-center gap-2 label bg-gold text-black px-4 py-3 shadow-lg hover:bg-[var(--nl-gold-hover)] transition-colors duration-300"
    >
      <Download size={16} /> Install app
    </button>
  );
};
